import React, { useEffect} from "react";

import PropTypes from 'prop-types';
import { isoDateToMMM, calcCampaignTotals } from "../../../utils";
import FieldTable, {variableCurrencyValue} from '../../../components/field-table';
import {ExchangeRatesContextValue, useExchangeRatesContext } from '../../../contexts/exchange-rates-context';
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import {useOutletContext} from "react-router-dom";
import {CampaignOutletContextValue} from "../form";
import {FieldTableColumnProps} from "../../../components/FieldTable/FieldTableTypes";
import {Ambient, AreaBooking, Experiential, MediaProduction, CreativeStudio, PanelBooking, Sundry} from "../../../generated/graphql";
import {useAreaPricingContext, useDaybookContext} from "../../../contexts/Daybook/DayBookContext";

type PanelSummaryComponent = {
    id: string,
    value: number,
    name: string,
    sites: Record<string, number>,
    posterSizes: Record<string, number>,
    qty?: number
};

const panelBookingSummary = (panelBookings,loading) => {
    const components: Record<string, PanelSummaryComponent> = {};
    panelBookings.forEach((panelBooking)=>{
        let region;
        if((panelBooking.is_slot || !panelBooking?.posterSize?.is_larger_than_4)) {
            return;
        }
        const site = panelBooking?.panel?.site;
        const component = panelBooking.campaignComponent;
        const posterSize = panelBooking.posterSize?.customer_name ? panelBooking?.posterSize?.customer_name : panelBooking?.posterSize?.name;
        if(component.regionType.name=='London') {
            region = 'London';
        } else {
            region = component.region.name;
        }
        if(!components[region]) {
            components[region] = {
                id: region,
                value: component.value*component.qty,
                name: region,
                sites:{[site.id]:1},
                posterSizes: {
                    [posterSize]:component.qty
                }
            };
        } else {
            components[region].value += component.value*component.qty;
            if(!components[region].sites[site.id]) {
                components[region].sites[site.id] =1;
                components[region].posterSizes[posterSize] = components[region].posterSizes[posterSize]?components[region].posterSizes[posterSize]+component.qty:component.qty;
            }

        }
    });
    const panelBookingSummaries = Object.values(components).sort((a, b) => {
        return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
    }).map((a) => {
        a.qty = Object.entries(a.sites).length;
        return a;
    });
    console.log('pbs',panelBookingSummaries);
    const panelFields:FieldTableColumnProps<PanelBooking>[] = [
        {accessor: 'name', header: 'Name', dataType:'default',readOnly:true},
        {accessor: 'qty', header: 'Sites',dataType:'number',readOnly:true},
        {
            accessor: 'posterSizes', header: 'Posters',
            readOnly:true,
            dataType:'default',
            options: {
                getValue: ({field}) => {
                    if (!field.value) return '';
                    return (Object.keys(field.value).sort().map((k) => {
                        return k + ': ' + field.value[k];
                    }).join(', '));
                }
            }
        },
        {
            accessor: 'value',
            className: 'column-currency',
            header: 'Total Cost',
            dataType:'currency',
            readOnly:true
        },
    ];
    return <FieldTable columns={panelFields}
    values={panelBookingSummaries}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
};
type ABSummaryComponentPosterSizes = {
    [key:string]:number
};

type ABSummaryComponent = {
    id:string,
    name:string,
    value:number,
    posterSizes:ABSummaryComponentPosterSizes
}


type ABSummaryComponents = {
    [key:string]:ABSummaryComponent
}

type FinancialRow = {
    id: string,
    name: string,
    amount?: number | { label: string; value: number | string }
}

const areaBookingSummary = (areaBookings:AreaBooking[],loading,daybook,calculateAreaBookingPricing,exchangeRatesContext:ExchangeRatesContextValue) => {
    const components:ABSummaryComponents = {};
/*    if(daybook.regionAreaBookingPricing) {*/
        areaBookings.forEach((areaBooking) => {
            areaBooking?.areaBookingItems?.forEach((areaBookingItem) => {
                if(!areaBookingItem) return;
                let region,qty;
                const component = areaBookingItem.campaignComponent;
                if(!component) return;
                if (areaBooking?.regionType?.name == 'London') {
                    region = 'London';
                } else {
                    region = component?.region?.name;
                }
                if(areaBooking.regionType?.has_split_qty) {
                    qty = (areaBookingItem.qty_sites??0) * (areaBookingItem.qty_posters_per_site??0);
                } else {
                    qty = component.qty;
                }
                const cost = exchangeRatesContext?.calcExchangeRate(areaBookingItem.campaignComponent?.currency,calculateAreaBookingPricing(areaBookingItem));
                console.log('[ABS]',cost,qty);
                if (!components[region]) {
                    components[region] = {
                        id: region,
                        value: cost * qty,
                        name: region,
                        posterSizes: {
                            [areaBooking.posterSize?.name??'default']: qty
                        }
                    };
                } else {
                    components[region].value += cost * qty;
                    components[region].posterSizes[areaBooking.posterSize?.name??'default'] = components[region].posterSizes[areaBooking.posterSize?.name??'default'] ?
                    components[region].posterSizes[areaBooking.posterSize?.name??'default'] + qty : qty;
                }
            });
        });
/*    } else {
        areaBookings.forEach((areaBooking) => {
            areaBooking.areaBookingItems?.forEach((areaBookingItem) => {
                if(!areaBookingItem) return;
                let region;
                const component = areaBookingItem.campaignComponent;
                if(!component) return;
                if (areaBooking?.regionType?.name == 'London') {
                    region = 'London';
                } else {
                    region = component?.region?.name??'Default';
                }
                if (!components[region]) {
                    components[region??'none'] = {
                        value: (component?.unit_value_local??0) * (component?.qty??0),
                        name: region,
                        posterSizes: {
                            [areaBooking.posterSize?.name??'default']: (component?.qty??0)
                        }
                    };
                } else {
                    components[region].value += (component.unit_value_local??0) * (component.qty??0);
                    components[region].posterSizes[areaBooking.posterSize?.name??'default'] = components[region].posterSizes[areaBooking.posterSize?.name??'default'] ?
                        components[region].posterSizes[areaBooking.posterSize?.name??'default'] + (component?.qty??0) : (component.qty??0);
                }
            });
        });
    }*/
    const areaBookingSummaries = Object.values(components).sort((a, b) => {
        return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
    });
    const areaFields = [
        {accessor: 'name', header: 'Name', dataType:'default',readOnly:true},
        {
            accessor: 'posterSizes', header: 'Posters', dataType:'default',readOnly:true,
            options: {
                getValue: ({field}) => {
                    if (!field.value) {
                        return '';
                    }
                    return (Object.keys(field.value).sort().map((k) => {
                        return k + ': ' + field.value[k];
                    }).join(', '));
                }
            }
        },
        {
            accessor: 'value',
            header: 'Total Cost',
            dataType:'currency',
            readOnly:true
        }
    ];
    return <FieldTable columns={areaFields}
    values={areaBookingSummaries}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
};

const ambientSummary = (ambientBookings:Ambient[]|Experiential[],loading,isAmbient) => {
    const ambientSummaries = Object.values(ambientBookings).sort((a, b) => {
        return a.campaignComponent?.region?.name < b.campaignComponent?.region?.name ? -1 : (a.campaignComponent?.region?.name > b.campaignComponent?.region?.name ? 1 : 0);
    });
    const areaFields:FieldTableColumnProps<Ambient|Experiential>[] = [
        {accessor: 'name', header: 'Notes', dataType:'default',readOnly:true},
        {accessor: 'campaignComponent.region.name', header: 'Region',dataType:'default',readOnly:true},
        {accessor: isAmbient ? 'ambientType.name' : 'experientialType.name', header: 'Type',readOnly:true,dataType:'default'},
        {accessor: 'start_date', header: 'Start', dataType:'date',readOnly:true},
        {accessor: 'end_date', header: 'End',dataType:'date',readOnly:true},
        {accessor: 'campaignComponent.qty', header: 'Qty',dataType:'number',readOnly:true},
        {
            accessor: 'campaignComponent',
            dataType:'currency',
            header: 'Total Cost',
            options: {
                getValue: ({field}) => (field.value.qty * field.value.unit_value_local),
                currency: {
                    accessor:'campaignComponent.currency'
                }
            },
            readOnly:true
        },
    ];
    return <FieldTable columns={areaFields}
    values={ambientSummaries}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
};

const otherCostsSummary = (sundries:Sundry[],loading) => {
    const sundrySummaries = Object.values(sundries).sort((a, b) => {
        return (a.name??'') < (b.name??'') ? -1 : ((a.name??'') > (b.name??'') ? 1 : 0);
    });
    const sundryFields:FieldTableColumnProps<Sundry>[] = [
        {accessor: 'name', header: 'Name',dataType:'default',readOnly:true},
        {accessor: 'sundryType.name', header: 'Type',dataType:'default',readOnly:true},
        {accessor: 'date_up', header: 'Date Up',dataType:'date',readOnly:true},
        {accessor: 'date_down', header: 'Date Down',dataType:'date',readOnly:true},
        {
            accessor: 'use_global_discount',
            header: 'Campaign Discount',
            dataType:'boolean',
            readOnly:true
        },
        {accessor: 'campaignComponent.qty', header: 'Qty',dataType: 'number',readOnly: true},
        {
            accessor: 'campaignComponent',
            header: 'Total Cost',
            dataType:'currency',
            readOnly: true,
            options:{
                getValue:({field}) => (field.value.qty * field.value.unit_value_local),
                currency: {
                    accessor:'campaignComponent.currency'
                }
            }
        }
    ];
    return <FieldTable columns={sundryFields}
    values={sundrySummaries}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
};

const mediaProductionSummary = (mediaProductions:MediaProduction[],loading) => {
    const mediaFields = [
        {accessor: 'mediaType.label', header: 'Media Type', dataType:'default',readOnly:true},
        {accessor: 'size.name', header: 'Size',dataType:'default',readOnly:true},
        {accessor: 'campaignComponent.qty', header: 'Qty',dataType:'number',readOnly:true},
        {
            accessor: 'campaignComponent', header: 'Total Cost', dataType:'currency',
            getValue: ({field}) => (field.value.qty * field.value.unit_value_local / field.value.price_divisor),
            readOnly:true,
            currency: {
                accessor:'campaignComponent.currency'
            }        
        }
    ];
    return <FieldTable columns={mediaFields}
    values={mediaProductions}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
};

const creativeStudioSummary = (creativeStudio:CreativeStudio[], loading) => {
    console.log("craetive valss", creativeStudio)
    const creativeFields = [
        {accessor: 'creativeStudioType.name', header: 'Creative Studio Type', dataType:'default',readOnly:true},
        {accessor: 'creativeStudioTypeDetail.name', header: 'Creative Studio Detail', dataType:'default',readOnly:true},
        {accessor: 'notes', header: 'Notes', dataType:'default',readOnly:true},
        {accessor: 'start_date', header: 'Start', dataType:'date',readOnly:true},
        {accessor: 'end_date', header: 'End',dataType:'date',readOnly:true},
        {accessor: 'campaignComponent.qty', header: 'Qty',dataType:'number',readOnly:true},
        {
            accessor: 'campaignComponent',
            dataType:'currency',
            header: 'Total Cost',
            options: {
                getValue: ({field}) => (field.value.qty * field.value.unit_value_local),
                currency: {
                    accessor:'campaignComponent.currency'
                }
            },
            readOnly:true
        },
    ];
    return <FieldTable columns={creativeFields}
    values={creativeStudio}
    loading={loading}
    hasExport={false}
    hasDelete={false}
    />
}

const CampaignOverview = () => {
    const { values, loading,setTab } = useOutletContext<CampaignOutletContextValue>();
    const daybook = useDaybookContext();
    const calculateAreaBookingPricing = useAreaPricingContext();
    useEffect(()=>{
        setTab('overview');
    },[]);
    const currency = values?.currency;
    const exchangeRatesContext = useExchangeRatesContext();
    //const staticClass = field.className+' '+Classes.UI_TEXT;
    //var isNew = values.id === 'new';
    const summaryValues = [
        {id: 'name', label: 'Name', value: values.name},
        {id: 'date', label: 'Date', value: isoDateToMMM(values.start_date) + ' to ' + isoDateToMMM(values.completion_date)}
    ];
    const summaryFields = [
        {
            accessor: 'label',
            className: 'column-right column-width-wide',
            dataType:'default'
        }, {
            accessor: 'value',
            dataType:'default',
            width:'narrow',
            readOnly:true
        }
    ];
    const financialColumns: FieldTableColumnProps<FinancialRow>[] = [{
        accessor: 'name',
        className: 'column-right column-width-wide'
    }, {
        accessor: 'amount',
        className: 'column-no-hide column-currency',
        dataType:'default',
        // eslint-disable-next-line react/display-name, react/prop-types
        options: {
            getValue:({row,field})=>{
                switch (row.name) {
                    case 'Discount':
                        return ((values.discount_percentage ? values.discount_percentage : 0)+'%');
                    default:
                        // eslint-disable-next-line
                        return variableCurrencyValue({currency:currency,value:field.value,qty:1,places:2});
                }

            }
        },
    }
    ];
    const campaignTotals = calcCampaignTotals({campaignValues:values, options:{isVatExempt: values?.is_vat_exempt}, exchangeRates:exchangeRatesContext,
        daybookConfig:daybook,
        calculateAreaBookingPricing});
    return (
        <div className="campaign__overview is-scrollable">
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Campaign Summary</AccordionSummary>
                <AccordionDetails>
                    <FieldTable columns={summaryFields}
                                values={summaryValues}
                                showHeadings={false}
                                loading={loading}
                                hasExport={false}
                                hasDelete={false}
                    />
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Financial Summary</AccordionSummary>
                <AccordionDetails>
<div className="grid12">
    <div className="grid12-6">
        <FieldTable columns={financialColumns}
                    values={campaignTotals.values.map((row) => ({ ...row, id: row.name }))}
                    showHeadings={false}
                    loading={loading}
                    hasExport={false}
                    hasDelete={false}
        />

    </div>
    <div className="grid12-6">
        <FieldTable columns={financialColumns}
                    values={campaignTotals.valuesB.map((row) => ({ ...row, id: row.name }))}
                    showHeadings={false}
                    loading={loading}
                    hasExport={false}
                    hasDelete={false}
        />
    </div>
</div>


                </AccordionDetails>
            </Accordion>
            {values.panelBookings && values.panelBookings.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Panel Bookings</AccordionSummary>
                    <AccordionDetails>
                        {panelBookingSummary(values.panelBookings,loading)}
                    </AccordionDetails>
                </Accordion>
            }
            {values.areaBookings && values.areaBookings.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Area Bookings</AccordionSummary>
                    <AccordionDetails>
                        {areaBookingSummary(values.areaBookings,loading,daybook,calculateAreaBookingPricing,exchangeRatesContext)}
                    </AccordionDetails>
                </Accordion>
            }
            {values.ambients && values.ambients.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Ambient Bookings</AccordionSummary>
                    <AccordionDetails>
                        {ambientSummary(values.ambients,loading,true)}

                    </AccordionDetails>
                </Accordion>
            }
            {values.experientials && values.experientials.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Experiential Bookings</AccordionSummary>
                    <AccordionDetails>
                        {ambientSummary(values.experientials,loading,false)}

                    </AccordionDetails>
                </Accordion>
            }
            {values.sundries && values.sundries.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Other Costs</AccordionSummary>
                    <AccordionDetails>
                        {otherCostsSummary(values.sundries,loading)}
                    </AccordionDetails>
                </Accordion>
            }
            {values.mediaProductions && values.mediaProductions.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Media Production</AccordionSummary>
                    <AccordionDetails>
                        {mediaProductionSummary(values.mediaProductions,loading)}
                    </AccordionDetails>
                </Accordion>
            }
             {values.creativeStudio && values.creativeStudio.length>0 &&
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>Creative Studio</AccordionSummary>
                    <AccordionDetails>
                        {creativeStudioSummary(values.creativeStudio,loading)}
                    </AccordionDetails>
                </Accordion>
            }
        </div>
    );
};

CampaignOverview.propTypes = {
    values: PropTypes.object,
    setValue: PropTypes.func,
    loading: PropTypes.bool
};

export default CampaignOverview;